import { TFunction } from 'i18next';
import { ConversationStatus } from '@/models/conversation.model';
import { TSelectOptions } from '@/ui';

export const getConversationStatusOptions = (t: TFunction): TSelectOptions<ConversationStatus> =>
  Object.values(ConversationStatus).map((conversationStatus) => ({
    label: t(`status_${conversationStatus}`),
    value: conversationStatus,
  }));
